import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CommsPreferencesGetDTO } from '../../shared/model/communication-preferences-get.dto';
import { Observable } from 'rxjs';
import { CommsPreferencesDTO } from '../../shared/model/communication-preferences.dto';

@Injectable({
  providedIn: 'root'
})
export class CommunicationPreferencesService {
  private readonly API_NAME = 'commsPreferences';

  constructor(private apiService: ApiService) {}

  // Get comms preferences
  public getCommsPreferences(tokenId?: string): Observable<CommsPreferencesGetDTO> {
    const params = tokenId ? { token: tokenId } : undefined;
    return this.apiService.get(this.API_NAME, `getCommsPreferences`, {
      params
    });
  }

  public getCommsPreferencesAdmin(clientId: string): Observable<CommsPreferencesGetDTO> {
    return this.apiService.get(this.API_NAME, `getCommsPreferencesAdmin`, {
      params: { clientId }
    });
  }

  // Set comms preferences
  public setCommsPreferences(commsPreferencesDto: CommsPreferencesDTO, tokenId?: string): Observable<void> {
    const params = tokenId ? { token: tokenId } : undefined;

    return this.apiService.post(this.API_NAME, `setCommsPreferences`, commsPreferencesDto, { params });
  }

  public setCommsPreferencesAdmin(commsPreferencesDto: CommsPreferencesDTO): Observable<void> {
    return this.apiService.post(this.API_NAME, 'setCommsPreferencesAdmin', commsPreferencesDto);
  }
}
